module.exports = __webpack_public_path__ + "static/media/calendar.decb7ed4.svg";